import axiosInstance from "../../../axios";
export const getBatchTableService = async (searchTerm, searchTermCatgeory) => {
  console.log(searchTermCatgeory, "work11111");
  try {
    const response = await axiosInstance.get(
      `/courses?courseName=${searchTerm}&category=${searchTermCatgeory}&pageNo=1&pageLength=9999`
    );
    console.log("Response data inside getCourseTableService:", response?.data);
    return response?.data;
  } catch (error) {
    console.error("Error in getCourseTableService:", error);
    throw error;
  }
};

export const getCourseBatches = async (params) => {
  try {
    const { data } = await axiosInstance.get("/batch/common-batch", {
      params: params,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getBatchSessions = async (id) => {
  try {
    const { data } = await axiosInstance.get(`/sessions/common-session/${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getBatchAllSessions = async (params) => {
  try {
    const { data } = await axiosInstance.get(`/sessions`, { params: params });
    return data;
  } catch (error) {
    throw error;
  }
};
